import {h, Fragment} from "preact"
export default function FacetSearchBar({name, handleChange}) {
    return (
        <div class="ns-input-facet-container ns-d-flex ns-px-4 ns-py-2">
            <img src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17458477068150.6685270738820113" alt="Brand Facet Search Icon" class="ns-search-facet-icon" />
            <input type="text"
                placeholder={`Search for ${name.toLowerCase()}`}
                class="ns-input-search ns-font-4"
                onInput={handleChange} 
            />
        </div>
    )
}